module.exports = __webpack_public_path__ + "img/xhs_code.3fe86aa5.png";